import { combineReducers } from '@reduxjs/toolkit'
import { baseApi } from 'shared/api/baseApi'
import { customApi } from 'shared/api/customApi'
import { fetchApi } from 'shared/api/fetchApi'

import { sessionReducer } from 'entities/session'
import { rolesReducer } from 'entities/roles'
import { userReducer } from 'entities/users'
import { globalReducer } from 'widgets/Sidebar/model/sideBarSlice'

export const rootReducer = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    [customApi.reducerPath]: customApi.reducer,
    [fetchApi.reducerPath]: fetchApi.reducer,
    session: sessionReducer,
    globalReducer: globalReducer,
    roles: rolesReducer,
    user: userReducer,
})
